<div class="pagination-new">
  <div  class="rows-per-page-new">
    <div *ngIf="showCustomDropdown" #dropdownWrapper class="custom-dropdown-new" (click)="toggleDropdown($event)" [class.open]="dropdownOpen">
      <span>{{ pageSize }} per page</span>
      <svg class="dropdown-arrow-new" width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.3334 1L7.47142 5.86193C7.21109 6.12227 6.78895 6.12227 6.52862 5.86193L1.66669 1"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <div class="dropdown-options-new" *ngIf="dropdownOpen">
        <div class="dropdown-header-new">Number per page</div>
        <hr />
        <div class="dropdown-item-new" *ngFor="let size of pageSizes" (click)="selectPageSize(size, $event)">
          {{ size }}
        </div>
      </div>
    </div>
    <span class="pagination-text-new">
      Showing {{ startIndex + 1 }} to {{ endIndex }} of {{ totalItems }} entries
    </span>
  </div>

  <div class="pager-new">
   <button (click)="prevPage()" [disabled]="currentPage === 1">
    <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.80716 11.4167L0.945266 6.55473C0.684913 6.2944 0.684912 5.87227 0.945259 5.61193L5.80716 0.75" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    Previous
  </button>
    <button *ngFor="let page of totalPagesArr"
            [class.active]="page === currentPage"
            (click)="goToPage(page)">
      {{ page }}
    </button>
   <button (click)="nextPage()" [disabled]="currentPage === totalPages">Next
    <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.75 0.75L5.61193 5.61193C5.87227 5.87227 5.87227 6.2944 5.61193 6.55473L0.75 11.4167" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
  </div>
</div>